import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
   get isOpen() {
      return this.element.open;
   }

   connect() {
      this.open();
   }

   toggle() {
      if (this.isOpen) {
         this.close();
      } else {
         this.open();
      }
   }

   open() {
      if (!this.isOpen) {
         this.element.showModal();
      }
   }

   close() {
      if (this.isOpen) {
         this.element.remove();
      }
   }
}